import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { EiqTextarea } from 'eiq-storybook';

import { removeInvalidXmlChars } from 'src/utils/helpers';
import s from 'src/components/CapFieldsNew/CapEditField.styles';

const CapEditTextAreaField = ({
  isEditable,
  name,
  wrapperClassName,
  value = '',
  rows,
  onBlur,
  hasLabel = false,
  label = 'N/A',
  errorMessage,
  editCommentClassname = ''
}) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(value);
  const [editField, setEditField] = useState(false);
  
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  if (!isEditable || !editField) {
    return (
      <>
      <s.Text 
        className={` ${editCommentClassname} ${isEditable ? 'editableText pl-15 pr-15' : 'pl-15 pr-15'}` } 
        onClick={() => setEditField(true)} >
        {inputValue || (hasLabel ? t(label) : <span className="placeholder">{t('CLICK_HERE_TO_ENTER_TEXT')}</span>)}
      </s.Text>
      {errorMessage && (
          <s.DatePickerFieldError className={'pl-15 pr-15'}>{errorMessage}</s.DatePickerFieldError>
        )}
      </>
    )
  }

  if (isEditable && editField) {
    return (
      <EiqTextarea
        name={name}
        autoFocus
        wrapperClassName={wrapperClassName}
        onBlur={() => {
          setEditField(false);
          onBlur(inputValue);
        }}
        value={inputValue}
        placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
        rows={rows}
        onFocus={(e) =>
          e.currentTarget.setSelectionRange(
          e.currentTarget.value.length,
          e.currentTarget.value.length
        )}
        onChange={(e) => setInputValue(removeInvalidXmlChars(e.target.value))}
        errorMessage={errorMessage}
      />
    );
  } 

  return null;
    
}

export default React.memo(CapEditTextAreaField);